import homesSrc from './assets/homes.svg';
import savingSrc from './assets/saving.svg';
import mortgageSrc from './assets/mortgage.svg';
import { IOnboardingSlide } from '../../types';

export const ONBOARDING_SLIDES: IOnboardingSlide[] = [
  {
    src: homesSrc,
    title: 'Подборки, чтобы помечтать',
    text: 'Переехать в центр или наоборот, загород? В квартиру попросторнее или поближе к метро? Посмотрите, как ваши мечты могут стать реальностью',
    hasNextButton: true,
  },
  {
    src: savingSrc,
    title: 'Начнём с вашей недвижимости',
    text: 'Уже оценили её стоимость — можно скорректировать оценку и добавить к сумме накопления, если есть',
    hasNextButton: true,
    hasPrevButton: true,
  },
  {
    src: mortgageSrc,
    title: 'Возьмём в расчёт ипотеку',
    text: 'Неплохой способ увеличить бюджет на покупку нового жилья',
    hasPrevButton: true,
    hasFinishButton: true,
  },
];
